"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const AssistantsBase_1 = __importDefault(require("./AssistantsBase"));
class Assistants extends AssistantsBase_1.default {
}
module.exports = Assistants;
